export default "__VITE_ASSET__DJppUbEX__"